import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useCollection } from "../../hooks/collections/useCollection";
import ComplexSidebarItem from "./ComplexSidebarItem";
import { useTranslation } from "react-i18next";
import theme from "../../styles/styleTheme";
import NAV from "../../utils/nav.const";
import { BoxPaper } from "../common/BoxPaper";

type ComplexSidebarProps = {
  property: any;
};

const ComplexSidebar = ({ property }: ComplexSidebarProps) => {
  const { t } = useTranslation();

  const {
    getDataById: getCollectionById,
    data: collectionData,
    loading: loadingCollection,
  } = useCollection();

  useEffect(() => {
    if (property) {
      getCollectionById(property.id);
    }
  }, [property]);

  return (
    <>
      {property?.properties?.length > 0 && (
        <BoxPaper
          style={{
            marginTop: "24px",
            paddingBottom: "24px",
          }}
        >
          {/* <Typography variant="h3">{t("complex.sidebar.title")}</Typography> */}
          {/* <Typography variant="body2" marginTop={1}>
            {t("complex.sidebar.availableProperties1")}{" "}
            {property?.propertyCollectionDetails?.propertyCount}{" "}
            {t("complex.sidebar.availableProperties2")}{" "}
            {property?.propertyCollectionDetails?.availablePropertyCount}{" "}
            {t("complex.sidebar.availableProperties3")}
          </Typography> */}
          <Box
            sx={{
              color: theme.palette.secondary.main,
              padding: ".8rem",
              borderRadius: "8px",
              textDecoration: "none",
              marginBottom: "1rem",
              display: "block",
              "&:hover": {
                backgroundColor: theme.palette.secondary.light,
                color: theme.palette.secondary.main,
              },
            }}
            component={Link}
            to={`/${NAV.PROPERTY_DETAILS}/${property?.urlSlug}`}
          >
            <Typography variant="h3" fontWeight={"bold"}>
              {collectionData?.title}
            </Typography>
          </Box>

          {collectionData?.properties?.map((childProperty: any) => (
            <ComplexSidebarItem
              key={childProperty.id}
              property={childProperty}
            />
          ))}
        </BoxPaper>
      )}
    </>
  );
};

export default ComplexSidebar;
